module.exports = __webpack_public_path__ + "img/aqi.807a951e.png";